import { DEFAULT_LANGUAGE } from '@procureai/schemas';
import { DefaultValues } from 'react-hook-form';
import { v7 as uuidv7 } from 'uuid';
import { z } from 'zod';

export const supplierContactSchema = z.object({
  internalId: z.string(),
  supplierId: z.string(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  role: z.string(),
  email: z.email(),
  language: z.string().transform((value) => value.toUpperCase()),
});
export type SupplierContactData = z.infer<typeof supplierContactSchema>;

export const supplierContactDataDefault: (
  data?: DefaultValues<SupplierContactData>,
) => DefaultValues<SupplierContactData> = (data) => ({
  internalId: uuidv7(),
  language: DEFAULT_LANGUAGE,
  email: '',
  firstName: '',
  lastName: '',
  ...data,
});
